module.exports = __webpack_public_path__ + "static/background-afbf8301b9ba096c0077e4fbddecedcd.png";